import React, {useState, useEffect} from 'react';
import {BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar, ResponsiveContainer} from "recharts";

import './ProcessMeasureGraph.css';
import {viewPDSAsForChangeIdea} from "../../../../../../../../services/PDSAService";

export const ProcessMeasureGraph = ({context, setSpinnerText, showToaster}) => {

    const [data, setData] = useState(null);
    const [bars, setBars] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setSpinnerText('Retrieving PDSAs');
            const [data, error] = await viewPDSAsForChangeIdea(context.username, context.changeIdeaScreen.externalReference);
            if (data) {
                if (data.responseStatus === "Success") {
                    mapProcessMeasures(data.pdsaVOs);
                    createBars(data.pdsaVOs);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const mapProcessMeasures = (PDSAList) => {
        const processMeasureData = [];
        const selectedPDSANumber = (context.PDSAScreen.name).substring(5, 6);
        const selectedPDSACycle = (context.PDSAScreen.name).substring(6, 7);
        PDSAList.forEach((PDSA) => {
            const PDSANumber = (PDSA.name).substring(5, 6);
            const PDSACycle = (PDSA.name).substring(6, 7);
            if (selectedPDSANumber === PDSANumber && selectedPDSACycle >= PDSACycle) {
                let mappedProcessMeasures = {
                    name: PDSA.name,
                }

                PDSA.processMeasures.forEach((processMeasure) => {
                    mappedProcessMeasures = {
                        ...mappedProcessMeasures,
                        [processMeasure.name]: +processMeasure.value,
                    }
                });

                processMeasureData.push(mappedProcessMeasures);
            }
        });

        processMeasureData.sort((processMeasureOne, processMeasureTwo) => processMeasureOne.name > processMeasureTwo.name);

        setData(processMeasureData);
    }

    const createBars = (PDSAList) => {
        const colors = [
            '#14BFDB',
            '#9A268E',
            '#04B14B',
            '#F56E3F',
            '#9D4EDD',
            '#C8242C',
            '#A7CE39',
            '#DE3F67',
            '#5C9AD2',
            '#FDBB15',
            '#447604',
            '#03045E',
            '#FB5012',
            '#466995',
            '#990B52',
            '#35FF69',
        ];

        const uniqueProcessMeasureNames = [];
        PDSAList.forEach((PDSA) => {
            PDSA.processMeasures.forEach((processMeasure) => {
                if (uniqueProcessMeasureNames.indexOf(processMeasure.name) === -1) {
                    uniqueProcessMeasureNames.push(processMeasure.name);
                }
            });
        });

        const bars = uniqueProcessMeasureNames.map((name, index) => {
            return <Bar dataKey={name} fill={colors[index]} key={index}/>
        });
        setBars(bars);
    }

    return (
        <div className="process-measure-graph-container">
            <ResponsiveContainer width='100%' height={475}>
                <BarChart data={data} margin={{left: -5}}>
                    <CartesianGrid/>
                    <XAxis dataKey="name"/>
                    <YAxis/>
                    <Tooltip/>
                    <Legend/>
                    {bars}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
